Cm.footer = {
    init: function() {
        
    },
};